export function readCookie(name: string) {
	const nameEQ = name + '=';
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function setCookie(name: string, value: string | number) {
	const date = new Date();
	date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
	document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

export const parseCookie = (str) => {
	if (!str) return {};

	return str
		.split(';')
		.map((v) => v.split('='))
		.reduce((acc, v) => {
			try {
				acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
			} catch (e) {
				console.error(e);
				acc[v[0].trim()] = v[1].trim();
			}
			return acc;
		}, {});
};
